import { SelectedRoomFilters } from 'entities/tour/models/selection-store/selection-store.ts'

export const hasActiveFilters = (filters: SelectedRoomFilters) =>
  Object.values(filters).some((arr) => arr.length > 0)
